'use strict';

/**
 * This module does not contain any Angular specific code
 */

module.exports = {
  Circle: require('./CircleLayer'),
  Marker: require('./MarkerLayer'),
  Polygon: require('./PolygonLayer'),
  Polyline: require('./PolylineLayer'),
  Rectangle: require('./RectangleLayer'),
  Overlay: require('./OverlayLayer'),

  // Helper methods
  getClassByType: function (type) {
    var types = {
      'circle': this.Circle,
      'marker': this.Marker,
      'polygon': this.Polygon,
      'polyline': this.Polyline,
      'text': this.Marker,
      'rectangle': this.Rectangle,
      'overlay': this.Overlay
    };

    var LayerClass = types[type.toLowerCase()];

    if (!LayerClass) {
      throw new Error('Unknown layer type: `' + type + '`');
    }

    return LayerClass;
  }
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/map/src/app/layer/edit/index.js